const Z_INDEX_LAYER = {
  LEVEL_1: -10000,
  LEVEL_2: 0,
  LEVEL_3: 1,
  LEVEL_4: 10,
  LEVEL_5: 25,
  LEVEL_6: 50,
  LEVEL_7: 100,
  LEVEL_8: 2500,
  LEVEL_9: 5000,
  LEVEL_10: 10000,
};

export { Z_INDEX_LAYER };
